<template>
    <div class="block-editor cache-extend">
        <div class="wrapper">
            <!-- Cache Key -->
            <section>
                <div class="title">{{ $t("tables.automationblock.cacheKey") }}</div>
                <TiptapEditor
                    :placeholder="$t('tables.automationblock.extendKeyPlaceholder')"
                    :show-attributes="true"
                    v-model="clone.key"
                    automation-mode
                />
                <div class="help-text">
                    <i class="material-icons">info</i>
                    <span>{{ $t("tables.automationblock.extendKeyHelp") }}</span>
                </div>
            </section>

            <!-- Expires At -->
            <section>
                <div class="title">{{ $t("tables.automationblock.newValidityTitle") }}</div>
                <div class="expires-config">
                    <CustomPicker
                        v-model="clone.expiresAt.mode"
                        :items="expiresModeOptions"
                        idKey="value"
                        labelKey="label"
                        :placeholder="$t('tables.automationblock.timeTypePlaceholder')"
                    />

                    <div v-if="clone.expiresAt.mode === 'duration'" class="duration-config">
                        <TiptapEditor
                            :placeholder="$t('tables.automationblock.durationValuePlaceholder')"
                            :show-attributes="true"
                            v-model="clone.expiresAt.duration.value"
                            automation-mode
                        />
                        <CustomPicker
                            v-model="clone.expiresAt.duration.unit"
                            :items="durationUnitOptions"
                            idKey="value"
                            labelKey="label"
                            :placeholder="$t('tables.automationblock.unitPlaceholder')"
                        />
                    </div>

                    <div v-if="clone.expiresAt.mode === 'timestamp'" class="timestamp-config">
                        <TiptapEditor
                            :placeholder="$t('tables.automationblock.isoDatePlaceholder')"
                            :show-attributes="true"
                            v-model="clone.expiresAt.timestamp.value"
                            automation-mode
                        />
                    </div>
                </div>
                <div class="help-text">
                    <i class="material-icons">schedule</i>
                    <span>{{ $t("tables.automationblock.validityFromNowHelp") }}</span>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import _ from "lodash";
import TiptapEditor from "../../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
import CustomPicker from "../../../../../../../components/pickers/CustomPicker.vue";

export default {
    name: "CacheExtend",
    components: {
        TiptapEditor,
        CustomPicker,
    },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep(this.value || {
                key: "",
                expiresAt: {
                    mode: "duration",
                    duration: {
                        value: "1",
                        unit: "hours",
                    },
                    timestamp: {
                        value: "",
                    },
                },
            }),
        };
    },
    computed: {
        expiresModeOptions() {
            return [
                { value: "duration", label: this.$t("tables.automationblock.expiresModeDurationLabel") },
                { value: "timestamp", label: this.$t("tables.automationblock.expiresModeTimestampLabel") },
            ];
        },
        durationUnitOptions() {
            return [
                { value: "seconds", label: this.$t("tables.automationblock.unitSecond") },
                { value: "minutes", label: this.$t("tables.automationblock.unitMinute") },
                { value: "hours", label: this.$t("tables.automationblock.unitHour") },
                { value: "days", label: this.$t("tables.automationblock.unitDay") },
            ];
        },
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss">
.block-editor.cache-extend {
    .wrapper {
        padding: 30px;

        section {
            margin-bottom: 20px;

            .title {
                margin-bottom: 10px;
                font-weight: 600;
                font-size: 16px;
                line-height: 20px;
            }

            .help-text {
                display: flex;
                align-items: flex-start;
                gap: 8px;
                margin-top: 8px;
                padding: 10px;
                background: #fff3cd;
                border-radius: 6px;
                font-size: 13px;
                color: #856404;

                .material-icons {
                    font-size: 18px;
                    color: #ffc107;
                }
            }

            .expires-config {
                display: flex;
                flex-direction: column;
                gap: 15px;

                .duration-config {
                    display: flex;
                    gap: 10px;
                    align-items: flex-start;

                    > :first-child {
                        flex: 2;
                    }

                    > :last-child {
                        flex: 1;
                    }
                }
            }
        }
    }
}
</style>

